<template>
  <div class="shop-container">
    <main class="bd-grid">
      <div
        v-for="product in props.modelValue"
        :key="product.id"
        class="product-item"
        @click="goToProduct(product.id)"
      >
        <div class="card">
          <div class="card-img">
            <div class="promo-tag" v-if="getPromoPrice(product) != 0">PROMO 🔥</div>
            <div class="wishlist-btn">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <img
              :src="getImage(product.image)"
              :alt="product.name"
              loading="lazy"
              decoding="async"
              width="300"
              height="300"
            />
          </div>

          <div class="card-content">
            <h3 class="card-name">{{ product.name }}</h3>
            <!--p class="card-desc">{{ product.description || 'Edition 2026 - pres a porter 100% coton made in algeria' }}</p-->

            <div class="price-container">
              <span class="green-dot">•</span>
              <span class="new-price" v-if="getPromoPrice(product) != 0">{{ getPromoPrice(product) }} DA</span>
              <span class="regular-price" v-else>{{ getBeforePrice(product) }} DA</span>
            </div>
          </div>

          <!--div class="product-variants" v-if="computedVariants[product.id]">
            <div
              v-if="
                computedVariants[product.id].models &&
                computedVariants[product.id].models.length > 1
              "
              class="variant-models"
            >
              <img
                v-for="(model, index) in computedVariants[
                  product.id
                ].models.slice(0, 4)"
                :key="'m-' + index"
                :src="getImage(model.image)"
                class="model-dot"
                :title="model.modelName"
              />
              <span
                v-if="computedVariants[product.id].models.length > 4"
                class="more-variants"
                >+{{ computedVariants[product.id].models.length - 4 }}</span
              >
            </div>
            <template v-else>
              <div
                class="variant-colors"
                v-if="computedVariants[product.id].colors.length > 0"
              >
                <span
                  v-for="(color, index) in computedVariants[
                    product.id
                  ].colors.slice(0, 4)"
                  :key="'c-' + index"
                  class="color-dot"
                  :style="{ backgroundColor: color.color }"
                  :title="color.color_name"
                ></span>
                <span
                  v-if="computedVariants[product.id].colors.length > 4"
                  class="more-variants"
                  >+{{ computedVariants[product.id].colors.length - 4 }}</span
                >
              </div>
              <div
                class="variant-sizes"
                v-if="computedVariants[product.id].sizes.length > 0"
              >
                <span
                  v-for="(size, index) in computedVariants[
                    product.id
                  ].sizes.slice(0, 3)"
                  :key="'s-' + index"
                  class="size-tag"
                  >{{ size.size }}</span
                >
                <span
                  v-if="computedVariants[product.id].sizes.length > 3"
                  class="more-variants"
                  >+{{ computedVariants[product.id].sizes.length - 3 }}</span
                >
              </div>
            </template>
          </div-->

          <div class="card-actions">
            <span class="see-product">{{ $t("seeProduct") || "See Product" }}</span>
            <!--button class="buy-btn-square">
              <svg xmlns="http://www.w3.org/2000/svg" class="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </button-->
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { defineProps } from "vue";

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
});

//console.log('props: ', props.modelValue)

const router = useRouter();


const getImage = (image) => {
  if (!image) return "/images/placeholder.png";
  return image.startsWith("https")
    ? image
    : `https://zoxcom.se7enwear.com${image}`;
};

const formatPrice = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  return Number(value) % 1 === 0 ? parseInt(value) : value;
};

const getBeforePrice = (product) => {
  const price =
    product.models?.[0]?.original || product.models?.[0]?.sell || "";
  return formatPrice(price);
};

const getPromoPrice = (product) => {
  const promo = product.models?.[0]?.promo || "";
  return formatPrice(promo);
};

const goToProduct = (id) => {
  router.push(`/produits/${id}`);
};

/*const computedVariants = computed(() => {
  const map = {};
  for (let product of props.modelValue) {
    const colors = [];
    const sizes = [];
    const models = [];
    if (product.models) {
      for (let model of product.models) {
        if (model.isActive == 1 || model.isActive === "1") {
          models.push({
            image: model.imageUrls || model.image,
            modelName: model.name || model.modelName,
          });
        }
        if (model.activeColor == 1 && model.details) {
          for (let d of model.details) {
            if (d.color && !colors.find((c) => c.color === d.color)) {
              colors.push({ color: d.color, color_name: d.colorName });
            }
          }
        }
        if (model.activeSize == 1 && model.details) {
          for (let d of model.details) {
            if (d.size && !sizes.find((s) => s.size === d.size)) {
              sizes.push({ size: d.size });
            }
          }
        }
      }
    }
    if (colors.length > 0 || sizes.length > 0 || models.length > 1) {
      map[product.id] = { colors, sizes, models };
    }
  }
  return map;
});*/
</script>

<style scoped>
.shop-container {
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.bd-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
  margin: 10px 0;
}

@media (max-width: 300px) {
  .bd-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }
  .shop-container {
    padding: 0 10px;
  }
}

.card {
  background: white;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  transition: transform 0.3s ease;
  height: 100%;
  border: none;
  box-shadow: none;
}

.card:hover {
  transform: translateY(-4px);
  border-color: var(--secondary);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.card-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f8fafc;
  position: relative;
  overflow: hidden;
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card:hover .card-img img {
  transform: scale(1.05);
}

.card-content {
  padding: 12px;
  text-align: left;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.card-name {
  font-weight: 700;
  color: #000;
  font-size: 1rem;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.price-container {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: auto; /* Push price to bottom of content area */
}

.new-price,
.regular-price {
  color: var(--dark);
  font-weight: 700;
  font-size: 1rem;
}

.old-price {
  text-decoration: line-through;
  color: #94a3b8;
  font-size: 0.85rem;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding: 12px;
}

.see-product {
  width: 100%;
  color: #000000;
  font-size: 0.85rem;
  font-weight: 500;
}

.buy-btn-square {
  background: #000000;
  color: #ffffff;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s;
}

.buy-btn-square:hover {
  opacity: 0.8;
}

.promo-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(221, 255, 243, 0.4);
  backdrop-filter: blur(4px);
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #000;
  z-index: 2;
}

.wishlist-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(221, 255, 243, 0.4);
  backdrop-filter: blur(4px);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  z-index: 2;
}

.wishlist-btn svg {
  width: 18px;
  height: 18px;
}

.card-desc {
  color: #6b7280;
  font-size: 0.8rem;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.green-dot {
  color: #10B981;
  font-size: 1.5rem;
  line-height: 0;
}


.btn-icon {
  width: 18px;
  height: 18px;
}

.buyBtn:hover {
  background: var(--accent);
}

.product-variants {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-block: 5px;
  margin-inline: 2px;
  align-items: center;
}

.variant-colors {
  display: flex;
  gap: 4px;
  align-items: center;
}

.color-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.variant-models {
  display: flex;
  gap: 4px;
  align-items: center;
}

.model-dot {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  object-fit: cover;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.variant-sizes {
  display: flex;
  gap: 4px;
  align-items: center;
}

.size-tag {
  font-size: 0.85rem;
  padding: 4px 8px;
  background: #f1f5f9;
  color: var(--dark);
  border-radius: 4px;
  font-weight: 600;
}

.more-variants {
  font-size: 0.7rem;
  color: var(--gray);
  font-weight: 600;
  margin-left: 2px;
}

/* Rating Styles */
.product-rating {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.stars {
  display: flex;
  gap: 1px;
}

.star {
  color: #e2e8f0;
  display: flex;
  align-items: center;
}

.star.filled {
  color: var(--secondary); /* Magical Gold */
}

.star-icon {
  width: 14px;
  height: 14px;
}

.rating-value {
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 500;
  padding-top: 2px;
}
</style>
